/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Winterinoccflowsetpoint3Inputs */



/**
* | output |
* | --- |
* | "Winter unoccupied flow setpoint" |
*
* @param {Ahu_History_Key_Winterinoccflowsetpoint3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_winterinoccflowsetpoint3 = /** @type {((inputs?: Ahu_History_Key_Winterinoccflowsetpoint3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Winterinoccflowsetpoint3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Winter unoccupied flow setpoint")
	return /** @type {LocalizedString} */ ("Consigne inoccupation hiver")
});
export { ahu_history_key_winterinoccflowsetpoint3 as "ahu_history_key_winterInoccFlowSetpoint" }